"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logProgramChange = logProgramChange;
var _sendToDatadog = require("./sendToDatadog");
/**
 * @description This method logs program changes to Datadog
 * @param origin
 */
function logProgramChange(origin) {
  (0, _sendToDatadog.sendToDatadog)('studio-programUpdate-tracker', {}, "Program update initialized in: ".concat(origin), false);
}